module.exports = __webpack_public_path__ + "static/1-543e6f204bb11b26fe00d557535efef0.jpg";